import { render, staticRenderFns } from "./WelcomeOnBoard.vue?vue&type=template&id=47f57b1e&scoped=true"
import script from "./WelcomeOnBoard.vue?vue&type=script&lang=js"
export * from "./WelcomeOnBoard.vue?vue&type=script&lang=js"
import style0 from "./WelcomeOnBoard.vue?vue&type=style&index=0&id=47f57b1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f57b1e",
  null
  
)

export default component.exports